import React from 'react';
import DragDropper, { dragDropperTypes } from './DragDropper';

const useDdp = false

const DragDropSimple = (props) => {

  const { cn_portal, groupChangeKey, positionProp, dndGroups, ddGroupsP, handleUpdateGroupItemChange } = props

  //sortedGroups is a group of objects with an array as the value

  const handleSorted = (ddg) => handleUpdateGroupItemChange(ddg)

  const getDropDownDropperGroups = () => {
    const ddg = {}
    if (useDdp) {
      Object.keys(ddGroupsP).forEach(pk => {
        const ddGroupP = ddGroupsP[pk]
        ddGroupP.forEach(ddGroup => {
          const { groupKey, dataItems, elements, caption } = ddGroup ? ddGroup : {}
          const hdd = <div>{caption}</div>
          ddg[groupKey] = { dataItems, elements, hdd }
        })
      })
    } else {
      Object.keys(dndGroups).forEach(groupKey => {
        const dndGroup = dndGroups[groupKey]
        const { dataItems, elements } = dndGroup ? dndGroup : {}
        const hdd = null
        ddg[groupKey] = { dataItems, elements, hdd }
      })
    }

    return ddg
  }

  const _ddGroups = getDropDownDropperGroups()

  return <DragDropper
    ddType={dragDropperTypes.settingsGroups}
    dndGroups={_ddGroups}
    handleSorted={handleSorted}
    groupChangeKey={groupChangeKey}
    allowSort={true}
    portalCn={cn_portal}
    positionProp={positionProp}
    headerColor={'grey'}
  />

}

export default DragDropSimple